var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:'chartdiv udp packet' + _vm.transceiverId,staticClass:"chart",attrs:{"id":'chartdiv udp packet' + _vm.transceiverId}})}
var staticRenderFns = []

export { render, staticRenderFns }